module.exports = __webpack_public_path__ + "img/n6.ebecb027.png";